import type { StateCreator } from 'zustand';

import { ToastType, type ToastSlice, type ToastState } from './types';

export type { ToastSlice, ToastState } from './types';
export { ToastType } from './types';

export const toastInitialState = {
  toast: null as ToastState | null,
};

// Auto-hide timeout reference
let toastTimeoutId: ReturnType<typeof setTimeout> | null = null;

export const createToastSlice: StateCreator<ToastSlice, [], [], ToastSlice> = (
  set
) => ({
  ...toastInitialState,

  showToast: (message, type = ToastType.Success) => {
    if (toastTimeoutId) clearTimeout(toastTimeoutId);
    set({ toast: { message, type } });
    const duration = type === ToastType.Error ? 12000 : 2000;
    toastTimeoutId = setTimeout(() => {
      set({ toast: null });
      toastTimeoutId = null;
    }, duration);
  },

  hideToast: () => {
    if (toastTimeoutId) {
      clearTimeout(toastTimeoutId);
      toastTimeoutId = null;
    }
    set({ toast: null });
  },
});
